module.exports = __webpack_public_path__ + "static/antai-logo-1bb3f247551c3b67194490d385a8baef.png";